<template>
    <b-overlay :show="getting" rounded="sm" opacity="0.2">
        <b-modal id="create-or-update" size="md" :title="editing ? 'Tip Güncelle' : 'Tip Oluştur'" no-close-on-esc no-close-on-backdrop>
            <case-type-form v-model="type" :errors="errors" :categories="categories" :editing="editing"></case-type-form>
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="handleCreateOrUpdate"></v-executer>
            </template>
        </b-modal>
        <b-modal id="create-or-update-category" size="md" :title="editingCategory ? 'Kategori Güncelle' : 'Kategori Oluştur'" no-close-on-esc no-close-on-backdrop>
            <case-category-form v-model="category" :errors="errors"></case-category-form>
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="handleCreateOrUpdateCategory"></v-executer>
            </template>
        </b-modal>

        <b-card no-body :class="!data. length ? 'p-3' : 'p-1'">
            <div class="d-flex align-items-center mb-1" v-if="data.length">
                <button v-b-tooltip.noninteractive.hover.bottom title="Kategori Ekle" v-on:click="createNewCategory()" class="btn  rounded-circle btn-icon btn-primary mr-25">
                    <feather-icon icon="PlusIcon"></feather-icon>
                </button>
                <button v-on:click="collapseAll" class="btn btn-sm btn-light ml-auto">
                    <feather-icon icon="MinusSquareIcon" class="mr-50"></feather-icon>
                    Hepsini Kapat
                </button>
            </div>
            <div v-for="(item,index) in data" :key="index" :class="index != 0 ? 'mt-1' : null">
                <div class="alert alert-dark mb-0">
                    <div class="alert-body px-50 py-25">
                        <div class="row align-items-center p-25">
                            <div class="col">
                                {{item.CategoryName}}
                            </div>
                            <div class="col-auto">
                                <button v-if="($safe(item,'Types') ||[]).length == 0" v-b-tooltip.noninteractive.hover.bottom title="Sil" v-on:click="delCategory(item)" class="btn btn-sm btn-icon btn-flat-danger ml-25">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Düzenle" v-on:click="editCategory(item)" class="btn btn-sm btn-icon btn-flat-secondary ml-25 mr-25">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Parametre Ekle" v-on:click="createNew(item)" class="btn btn-sm rounded-circle btn-icon btn-primary mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <v-tree-view ref="treeViews" v-model="item.Types" >
                    <template #data="{data}">
                        <div class="row align-items-center">
                            <div class="col">
                                <b>{{data.Name}}</b>
                            </div>
                            <div class="col-auto text-right">
                                <button v-if="($safe(data,'Children') ||[]).length == 0" v-b-tooltip.noninteractive.hover.bottom title="Sil" v-on:click="del(data)" class="btn btn-sm btn-icon btn-flat-danger ml-25">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Düzenle" v-on:click="edit(data)" class="btn btn-sm btn-icon btn-flat-secondary ml-25 mr-25">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom title="Alt Parametre Ekle" v-on:click="createNew(data)" class="btn btn-sm rounded-circle btn-icon btn-primary ml-25 mr-25">
                                    <feather-icon icon="PlusIcon"></feather-icon>
                                </button>
                            </div>
                        </div>
                    </template>
                </v-tree-view>  
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { BCard, BOverlay, VBTooltip } from 'bootstrap-vue';
import IncidentOperationsApi from '@/api/incident-operations';
import VTreeView from '@/components/v-tree-view/VTreeView'
import { data } from 'vue-echarts';
import CaseTypeForm from "./components/CaseTypeForm.vue";
import CaseCategoryForm from "./components/CaseCategoryForm.vue";

export default {
    components:{
        BCard,
        BOverlay,
        VTreeView,
        CaseTypeForm,
        VBTooltip,
        CaseCategoryForm
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data(){
        return {
            data:[],
            getting:false,
            editing:false,
            editingCategory:false,
            categories: [],
            errors:{},
            loading:false,
            category: {
                Id: null,
                Name: null,
            },
            type: {
                _create:false,
                Id: null,
                Name: null,
                CategoryId: null,
                ParentId: null,
            },
        }
    },
    mounted(){
        this.get()
        this.getCategories()
    },
    methods:{
        getCategories() {
            IncidentOperationsApi.CaseCategory.List()
                .then((res) => {
                    if (res.data.Success) {
                        this.categories = res.data.Data;
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },
        get(){
            this.getting = true
            IncidentOperationsApi.TreeView().then(res => {
                if(res.data.Success){
                    this.data = res.data.Data || []
                } else this.$result(res)
                this.getting = false
            }).catch(err => {
                this.$result(null,err)
                this.getting = false
            })
        },
        collapseAll(){
            this.$refs.treeViews.forEach(tv=> tv.collapseAll())
        },
        clearFormCategory() {
            this.errors = {};
            this.editing = false;
            this.category.Id = null;
            this.category.Name = null;
        },
        createNewCategory() {
            this.clearFormCategory();
            this.$showModal("create-or-update-category");
        },
        editCategory(item) {
            this.clearFormCategory();
            this.editing = true;
            this.category.Id = item.CategoryId;
            this.category.Name = item.CategoryName;
            this.$showModal("create-or-update-category");
        },
        clearForm(){
            this.editing = false
            this._create = false
            this.type.Id = null
            this.type.Name = null
            this.type.CategoryId = null
            this.type.ParentId = null
        },  
        edit(data){
            this.clearForm()
            this.editing = true
            this._create = false
            this.type.Id = data.Id
            this.type.Name = data.Name
            this.type.CategoryId = data.CategoryId
            this.type.ParentId = data.ParentId
            this.$showModal("create-or-update");
        },
        createNew(data){
            this.clearForm()
            this.type._create = true
            this.type.ParentId = data.Id
            this.type.CategoryId = data.CategoryId
            this.$showModal("create-or-update");
        },  
        del(data){
            this.$confirm('Silmek isteidğinize emin misiniz?',`Bu işlem ${data.Name} isimli parametre tipini silecektir.`).then(res => {
                if(res){
                    IncidentOperationsApi.CaseType.Delete(data.Id).then((res) => {
                        this.$result(res);
                        if (res.data.Success) {
                            this.get();
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                    })
                }
            })
        },
        handleCreateOrUpdate() {
            this.loading = true;
            IncidentOperationsApi.CaseType.CreateOrUpdate(this.editing, this.type)
            .then((res) => {
                this.$result(res);
                if (res.data.Success) {
                    this.$hideModal("create-or-update");
                    this.get();
                }
            })
            .catch((err) => {
                this.$result(null, err);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        delCategory(item) {
            this.$confirm('Silmek isteidğinize emin misiniz?',`Bu işlem ${item.CategoryName} isimli kategoriyi silecektir.`).then(res => {
                if(res){
                IncidentOperationsApi.CaseCategory.Delete(item.CategoryId)
                    .then((res) => {
                        this.$result(res);
                        if (res.data.Success) {
                            this.get();
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                    })
                }
            })
        },
        handleCreateOrUpdateCategory() {
            this.loading = true;
            IncidentOperationsApi.CaseCategory.CreateOrUpdate(this.editing, this.category)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.$hideModal("create-or-update-category");
                        this.get();
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                })
        },
    }
}
</script>